import { render } from "./MultiStepInstanceForm.vue?vue&type=template&id=3210e1f9"
import script from "./MultiStepInstanceForm.vue?vue&type=script&lang=js"
export * from "./MultiStepInstanceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__